import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MessageBubble = ({ message, senderName, senderAvatar, timestamp, isOwn, type, fileName, fileSize, senderType, aiModel }) => {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`flex gap-3 mb-4 ${isOwn ? 'flex-row-reverse' : 'flex-row'}`}>
      <div className="flex-shrink-0">
        {senderAvatar ? (
          <Image
            src={senderAvatar}
            alt={`${senderName} profile photo`}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
        )}
      </div>

      <div className={`flex-1 max-w-[70%] ${isOwn ? 'items-end' : 'items-start'} flex flex-col`}>
        <div className="flex items-center gap-2 mb-1">
          <span className={`text-sm font-medium text-foreground ${isOwn ? 'order-2' : 'order-1'}`}>
            {senderName}
          </span>
          {senderType === 'ai' && (
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-accent/10 text-accent ${isOwn ? 'order-1' : 'order-2'}`}>
              <Icon name="Bot" size={12} />
              {senderName}
            </span>
          )}
          {senderType === 'human' && !isOwn && (
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success/10 text-success ${isOwn ? 'order-1' : 'order-2'}`}>
              <Icon name="User" size={12} />
              Human
            </span>
          )}
          <span className={`text-xs text-muted-foreground ${isOwn ? 'order-1' : 'order-3'}`}>
            {formatTime(timestamp)}
          </span>
        </div>

        {type === 'file' ? (
          <div
            className={`
              p-4 rounded-lg border border-border bg-card
              ${isOwn ? 'rounded-tr-none' : 'rounded-tl-none'}
            `}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="FileText" size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{fileName}</p>
                <p className="text-xs text-muted-foreground">{fileSize}</p>
              </div>
              <button className="p-2 hover:bg-muted rounded-lg transition-smooth">
                <Icon name="Download" size={18} color="var(--color-foreground)" />
              </button>
            </div>
          </div>
        ) : (
          <div
            className={`
              px-4 py-3 rounded-lg
              ${isOwn
                ? 'bg-primary text-primary-foreground rounded-tr-none'
                : 'bg-muted text-foreground rounded-tl-none'
              }
            `}
          >
            <p className="text-sm whitespace-pre-wrap break-words">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;